import React from "react";
import { Icon } from "@iconify/react";

export const memberTypeList = [
  {
    icon: (
      <div style={{ textAlign: "center" }}>
        <Icon width="25" icon="fa-solid:male" />
        <Icon
          width="20"
          icon="fa:plus"
          style={{ marginLeft: 10, marginBottom: 32 }}
          size="2x"
        />
      </div>
    ),
    text: "Ein volljähriges Mitglied hinzufügen",
    info: "Hier können Sie ein Mitglied anlegen und für dieses Mitglied auch direkt weitere Vertragsinformationen wie Kontakt- oder Bankdaten eingeben. Wählen Sie diese Option, falls Ihr Mitglied bereits erwachsen bzw. volljährig ist und selbst den Vertrag unterzeichnet hat.",
    type: "adult",
  },
  {
    icon: (
      <div style={{ textAlign: "center" }}>
        <Icon width="30" icon="fa:child" />
        <Icon
          width="20"
          icon="fa:plus"
          style={{ marginLeft: 10, marginBottom: 26 }}
          size="2x"
        />
      </div>
    ),
    text: "Ein Kind als Mitglied hinzufügen",
    info: "Möchten Sie ein Kind hinzufügen, so können Sie anschließend noch Vertragsdaten eingeben; falls Sie Kontakt- oder Bankdaten der Eltern oder Erziehungsberechtigten verwalten möchten.",
    type: "child",
  },
  {
    icon: (
      <div style={{ textAlign: "center" }}>
        <Icon width="40" icon="fa-solid:user-plus" />
        <Icon
          width="40"
          icon="fa:address-card"
          style={{ marginLeft: 10, marginBottom: 5 }}
          size="3x"
        />
      </div>
    ),
    text: "Einem bestehenden Vertrag ein Mitglied hinzufügen",
    info: "Haben Sie zum Beispiel bereits einen Vertrag für ein Kind angelegt und es soll diesem Vertrag nun ein weiteres Kind zugeordnet werden, wählen Sie diese Option.",
    type: "addMemberToContract",
  },
];

export const contractMemberTypeList = [
  {
    icon: (
      <div style={{ textAlign: "center" }}>
        <Icon width="20" icon="fa-solid:male" />
        <Icon
          width="20"
          icon="fa:plus"
          style={{ marginLeft: 10, marginBottom: 26 }}
          size="2x"
        />
      </div>
    ),
    text: "Ein volljähriges Mitglied hinzufügen",
    info: "Das Mitglied wird als erwachsene Person hinzugefügt.",
    type: "adult",
  },
  {
    icon: (
      <div style={{ textAlign: "center" }}>
        <Icon width="40" icon="fa:child" />
        <Icon
          width="40"
          icon="fa:plus"
          style={{ marginLeft: 10, marginBottom: 26 }}
          size="2x"
        />
      </div>
    ),
    text: "Ein Kind als Mitglied hinzufügen",
    info: "Das Mitglied wird als Kind hinzugefügt",
    type: "child",
  },
];
